export function filterObject<T>(
  o: { [key: string]: T },
  predicate: (key: string, v: T) => boolean,
): { [key: string]: T } {
  return Object.fromEntries(Object.entries(o).filter(([k, v]) => predicate(k, v)));
}

export function recordsEqual(r1: Record<string, unknown>, r2: Record<string, unknown>): boolean {
  if (r1 === undefined) {
    return r2 === undefined;
  }

  const k1 = Object.keys(r1);
  const k2 = Object.keys(r2);
  if (k1.length !== k2.length) {
    return false;
  }
  return k1.every((key) => r1[key] === r2[key]);
}
